module.exports = __webpack_public_path__ + "static/foto3-43ec2ca18639757544fcdb26e4444eb4.jpg";